module.exports = __webpack_public_path__ + "img/accesscourses.6687005f.svg";